import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import { ImageLink } from '../constants'
import CommonEditor from './CommonEditor'

const AddProjectdetails = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state

    const [projectData, setProjectData] = useState([]);

    const [data, setData] = useState({
        projectId: editData?.projectId?._id || '',
        projectBy: editData?.projectBy || '',
        projectContent: editData?.projectContent || '',
        projectProcess: editData?.projectProcess || '',
        reraNumber: editData?.reraNumber || '',
        projectBanner: editData?.projectBanner || '',
        projectLogo: editData?.projectLogo || '',
        // isActive: editData?.isActive || false,
    });

    const [errors, setErrors] = useState({
        projectId: '',
        projectBy: '',
        projectContent: '',
        reraNumber: '',
        projectProcess: '',
        projectBanner: '',
        projectLogo: '',
    });

    const handleChange = (e) => {
        const { name, files, checked, value } = e.target;
        if (name === 'projectBanner' || name === 'projectLogo') {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else if (name === "isActive") {
            setData({ ...data, [name]: checked });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Validate email
        if (!data.projectId.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectId: 'Project is required'
            }));
            hasErrors = true;
        }
        if (!data.projectBy.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectBy: 'Project by is required'
            }));
            hasErrors = true;
        }
        if (!data.projectProcess.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectProcess: 'Process is required'
            }));
            hasErrors = true;
        }
        if (!data.projectBanner) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectBanner: 'banner img is required'
            }));
            hasErrors = true;
        }
        if (!data.projectLogo) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectLogo: 'Logo img is required'
            }));
            hasErrors = true;
        }

        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("projectBy", data.projectBy);
            formData.append("projectContent", data.projectContent);
            formData.append("projectId", data.projectId);
            formData.append("projectProcess", data.projectProcess);
            formData.append("reraNumber", data.reraNumber);
            if (data.projectBanner instanceof File) {
                formData.append("projectBanner", data.projectBanner);
            }
            if (data.projectLogo instanceof File) {
                formData.append("projectLogo", data.projectLogo);
            }
            // formData.append("isActive", data.isActive);

            const response = await axiosInstance.post(`project/createProjectDetails`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-details");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("projectBy", data.projectBy);
            formData.append("projectContent", data.projectContent);
            formData.append("projectId", data.projectId);
            formData.append("projectProcess", data.projectProcess);
            formData.append("reraNumber", data.reraNumber);
            if (data.projectBanner instanceof File) {
                formData.append("projectBanner", data.projectBanner);
            }
            if (data.projectLogo instanceof File) {
                formData.append("projectLogo", data.projectLogo);
            }
            // formData.append("isActive", data.isActive);

            const response = await axiosInstance.put(`project/updateProjectDetails/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-details");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`project/getWithoutPaginationProject`);
            const { data } = response.data;
            setProjectData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="page-title">Add Project Details</h3>
                </div>
                <div className="row grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername1"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project Name
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="exampleFormControlSelect1"
                                                name='projectId'
                                                value={data.projectId}
                                                onChange={handleChange}
                                            >
                                                <option value="" disabled>-- Please Select Project --</option>
                                                {projectData.map(item => (
                                                    <option key={item._id} value={item._id}>{item.title}</option>
                                                ))}
                                            </select>
                                            {errors.projectId && <p className="text-danger">{errors.projectId}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Page Banner
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="projectBanner"
                                                name="projectBanner"
                                                placeholder="Enter banner"
                                                //value={data.projectBanner}
                                                onChange={handleChange}
                                            />
                                            {errors.projectBanner && <p className="text-danger">{errors.projectBanner}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project Logo
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="projectLogo"
                                                name="projectLogo"
                                                placeholder="Enter logo"
                                                //value={data.projectLogo}
                                                onChange={handleChange}
                                            />
                                            {errors.projectLogo && <p className="text-danger">{errors.projectLogo}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project By
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="projectBy"
                                                name="projectBy"
                                                placeholder="Enter projectby"
                                                value={data.projectBy}
                                                onChange={handleChange}
                                            />
                                            {errors.projectBy && <p className="text-danger">{errors.projectBy}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Construction Status
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="projectProcess"
                                                name="projectProcess"
                                                placeholder="Enter process"
                                                value={data.projectProcess}
                                                onChange={handleChange}
                                            />
                                            {errors.projectProcess && <p className="text-danger">{errors.projectProcess}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Rera Number
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="reraNumber"
                                                name="reraNumber"
                                                placeholder="Enter rera number"
                                                value={data.reraNumber}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project Description
                                        </label>
                                        <div className="col-sm-9">
                                            <CommonEditor
                                                value={data.projectContent}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'projectContent', value } })}
                                            />
                                            {errors.projectContent && !data?.projectContent?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )}
                                        </div>
                                        {/* <div className="col-sm-9">
                                            <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="projectContent"
                                                name="projectContent"
                                                placeholder="Enter content"
                                                value={data.projectContent}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.projectContent && <p className="text-danger">{errors.projectContent}</p>}
                                        </div> */}
                                    </div>
                                    {/* <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 "
                                        >Is Active
                                        </label>
                                        <div className="col-sm-9">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox" className="custom-control-input"
                                                    name='isActive'
                                                    id="isActiveSwitch"
                                                    checked={data.isActive}
                                                    onChange={(e) => handleChange(e)} />
                                                <label className="custom-control-label " for="isActiveSwitch">{data.isActive === true ? "Active" : "Deactive"}</label>

                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label"></label>
                                                <div className="col-sm-9">

                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className='text-center mt-4'>
                                        <Link to="/project-details"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {data.projectBanner &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Banner Image Preview</p>
                                    <br />
                                    {data.projectBanner instanceof File ? (
                                        <img src={URL.createObjectURL(data.projectBanner)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.projectBanner)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>
                            }
                            {data.projectLogo &&
                                <div className="border w-100 h-80 text-center mb-4">
                                    <h6 className="mt-3">Logo Image Preview</h6>
                                    <br />
                                    {data.projectLogo instanceof File ? (
                                        <img src={URL.createObjectURL(data.projectLogo)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.projectLogo)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddProjectdetails;